// extracted by mini-css-extract-plugin
export default {"gridBox":"footer_gridBox__LQ336","flexBox":"footer_flexBox__r1ZNk"};